import { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-bootstrap';

import Spinner from '../../../commonComponents/Spinner/Spinner';

// Usage example: see BooksMissingAnswersReport.jsx
export default function ReportWithoutCriteria({
  name,
  link,
  currentState,
  stateLoading,
  stateError,
  stateSuccess,
  getLatestFunc,
  generateFunc,
}) {
  const downloadRef = useRef(null);
  const [doDownload, setDoDownload] = useState(false);

  useEffect(() => {
    getLatestFunc();
  }, []);

  useEffect(() => {
    let timeout;
    let delay = 3000;
    const poll = () => {
      timeout = setTimeout(() => {
        getLatestFunc();
        delay = Math.min(delay * 2, 30000); // check: 3s, 6s, 12s, 24s, 30s, 30s...
        poll();
      }, delay);
    };
    if (currentState === stateLoading) {
      poll();
    }
    return () => clearTimeout(timeout);
  }, [currentState]);

  useEffect(() => {
    if (doDownload && currentState === stateSuccess && downloadRef.current) {
      downloadRef.current.click();
    }
  }, [currentState, doDownload, downloadRef]);

  const handleDownload = (e) => {
    if (!link || link.length === 0) {
      setDoDownload(true);
      // Prevent reloading the page if there aren't any previous reports
      e.preventDefault();
    } else {
      getLatestFunc();
      setDoDownload(false);
    }
  };

  const handleGenerate = () => {
    generateFunc();
    setDoDownload(true);
  };

  // Unknown or uninitialized state, silent initial loading
  if (
    !currentState ||
    (currentState !== stateLoading &&
      currentState !== stateSuccess &&
      currentState !== stateError)
  ) {
    return <Spinner />;
  }

  // LOADING: generating report in background
  if (currentState === stateLoading) {
    return (
      <>
        <Row>
          <Col>
            <h3>{name}</h3>
          </Col>
        </Row>
        <Row>
          <Col>
            <Spinner text="Generating report, this may take a while..." />
          </Col>
        </Row>
      </>
    );
  }
  return (
    <>
      <Row>
        <Col>
          <h3>{name}</h3>
        </Col>
      </Row>
      <Row>
        <Col className="d-block col-6">
          <a href={link} style={{ textDecoration: 'none' }}>
            <div
              className="whiteButtons"
              onClick={handleDownload}
              ref={downloadRef}
            >
              Download Latest
            </div>
          </a>
        </Col>
        <Col className="d-block col-6">
          <div className="whiteButtons" onClick={handleGenerate}>
            Generate
          </div>
        </Col>
      </Row>
      {currentState === stateError && (
        <Row>
          <Col>
            <div className="error">
              Error retrieving latest or generating report. Please try again.
            </div>
          </Col>
        </Row>
      )}
    </>
  );
}
